export const CHECKOUT_LINKS = {
  base: 'https://checkout.tusbeneficios.shop/cart/51497475506409:1',
  pro: 'https://checkout.tusbeneficios.shop/cart/51497475571945:1',
} as const

export function goToCheckout(plan: 'base' | 'pro') {
  window.location.href = CHECKOUT_LINKS[plan]
}
